import {createModel} from '@@/package/utils/ModelUtil';
import Model from '@@/package/mapper/Model';
import {CodeHintModel} from "~~/package/mapper/learning/model/CodeHintModel";
import {CodeInputModel} from "~~/package/mapper/learning/model/CodeInputModel";
import {CodeSelectionModel} from "~~/package/mapper/learning/model/CodeSelectionModel";
import {CodeOrderModel} from "~~/package/mapper/learning/model/CodeOrderModel";
import {LangType} from "~~/package/mapper/learning/model/LangType";
import {MultipleChoiceQuestionModel} from "~~/package/mapper/learning/model/MultipleChoiceQuestionModel";
import {CodeQuestionModel} from "~~/package/mapper/learning/model/CodeQuestionModel";

export class TaskModel extends Model {
    constructor(
        public id: number = 0,
        public skillId: number = 0,
        public title: string = "",
        public description: string = "",
        public defaultCode: string = "",
        public type: string = "",
        public content: string = "",
        public learningTime: number = 0,
        public level: number = 1,
        public langType: LangType = LangType.PYTHON,
        public inCorrectAnswerCodeCount: number = 0,
        public submitCode: string = "",
        public question: string = "",
        public submissionCode: string = "", // only use -> level assessment
        public hintList: CodeHintModel[] = [],
        public markQuestionList: CodeQuestionModel[] = [],
        public markDictationList: CodeInputModel[] = [],
        public markSelectionList: CodeSelectionModel[] = [],
        public markOrderList: CodeOrderModel[] = [],
        public multipleChoiceQuestion: MultipleChoiceQuestionModel = new MultipleChoiceQuestionModel(),
        public outputDescription: string = "", // GA error 관리 다국어 적용 시 삭제 필요
        public referenceUrl: string = "",
        public embedUrl: string = "",
        public previewUrl: string = "",
        public charcLengthLimit: number = -1
    ) {
        super();
    }

    public static create(model: Partial<TaskModel>): TaskModel {
        return createModel<TaskModel>(TaskModel, {
            ...model
        });
    }
}
